import React, { Component } from "react";
import PropTypes from "prop-types";

import VariablesPreview from "./VariablesPreview/VariablesPreview";
import { VariableListBuilder } from "../../VariableList";
import ModalBuilder from "./Modal";

class VariablesBuilder extends Component {
  handleSelect = selectedVariables => {
    const { onSelect } = this.props;
    onSelect(selectedVariables);
  };

  render() {
    const {
      toggle,
      isOpen,
      selectedVariables,
      isCategoriesLoading
    } = this.props;
    return (
      <>
        {!selectedVariables.length ? (
          <VariablesPreview onAddVariables={toggle} />
        ) : (
          <VariableListBuilder list={selectedVariables} />
        )}
        {isOpen && (
          <ModalBuilder
            selectedVariables={selectedVariables}
            isOpen={isOpen}
            onSelect={this.handleSelect}
            toggle={toggle}
            isCategoriesLoading={isCategoriesLoading}
          />
        )}
      </>
    );
  }
}

VariablesBuilder.propTypes = {
  selectedVariables: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))),
  onSelect: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  isCategoriesLoading: PropTypes.bool.isRequired
};

VariablesBuilder.defaultProps = {
  selectedVariables: [],
  isOpen: false
};

export default VariablesBuilder;
